import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import gist from './gist';
import auth from './auth';
import modal from './modal';

export default new Vuex.Store({
    strict: true,
    modules: {
        gist,
        auth,
        modal,
    },
});
